import { UserActionTypes } from '@bridebook/web/lib/users/action-types';
import type { IUserSerialized } from '@bridebook/web/lib/users/types';

export const onUserListener = (user: IUserSerialized | null) => ({
  type: UserActionTypes.ON_USER_LISTENER,
  payload: user,
});
